/*
WISHLIST

classes nested in "classes" object
hover events
groups

*/

// const { Howler } = require('../apis/howler/howler');

/**
 * @param slideObj
 * @param settings
 * @param $hotspots
 * @param modals
 */
function hotspotFunctions(slide, settings, $hotspots, modals) {
	var slide = slide || globalVar.slide;
	var settings = settings || slide.data.hotspot || (slide.data.hotspot = {});
	var $hotspots = $hotspots || slide.$.find('.hotspot-button__js');
	var modals = modals || getHotspotModals($hotspots.length);

	if (!slide.data.visited) hotspotInit(slide.data, settings, $hotspots, modals);

	resetHotspot(settings, $hotspots, modals);
}

/**
 * @param slideObj
 * @param settings
 * @param $hotspots
 * @param modals
 */
function hotspotInit(slideObj, settings, $hotspots, modals) {
	hotspotSetDefaults(settings, modals);
	hotspotDOMSetup(slideObj, settings, $hotspots, modals);
	hotspotAudioInit(settings.audio);

	hotspotListeners(settings, $hotspots, function (idx, hotspot) {
		return function () {
			hotspotOnInteract(settings, $hotspots, modals, idx, $(hotspot), modals[idx]);
		};
	});

	hotspotOnExit(slideObj);
}

/**
 * @param settings
 * @param $hotspots
 * @param modals
 */
function resetHotspot(settings, $hotspots, modals) {
	var slide = globalVar.slide;

	var settings = settings || slide.data.hotspot;
	var $hotspots = $hotspots || slide.$.find('.hotspot-button__js');
	var modals = modals || getHotspotModals($hotspots.length);

	$hotspots.removeClass(settings.classes.completed);

	if (settings.linear) hotspotLinearReset(settings, $hotspots, modals);
	if (settings.quiz) hotspotQuizReset(settings, $hotspots);
}

/**
 * @param settings
 * @param $hotspots
 * @param idx
 * @param $selectedHotspot
 * @param $modal
 */

function hotspotOnInteract(settings, $hotspots, modals, idx, $selectedHotspot, $modal) {
	var itemNum = idx + 1;
	var hasModals = settings.modals;
	var itemSettings = getItemSettings(settings.items, $selectedHotspot[0].id, itemNum);
	var modalDoesNotTriggerCompletion = !hasModals || settings.modals.noModalClose;

	hotspotCustomAction(settings.onClick, itemSettings && itemSettings.onClick, $selectedHotspot, $modal);
	hotspotPlayVO(settings, itemNum);

	if (settings.quiz) return hotspotOnQuizItemSelected(settings, $hotspots, $selectedHotspot);

	if (hasModals) {
		hotspotCloseRemainingModals(settings, $('.si-current-modal'), $('.hotspot-open'));
		hotspotOpenModal(settings, itemNum, $selectedHotspot, $modal);

		if (settings.modals.hover) hotspotCloseOnMouseOut($selectedHotspot, $modal);
	}

	if (modalDoesNotTriggerCompletion) {
		hotspotItemComplete(settings, $hotspots, itemSettings, $selectedHotspot, $modal);

		if (settings.linear)
			hotspotUnlockNext(settings, $hotspots, itemNum + 1, $($hotspots[idx + 1]), modals[idx + 1]);
	}
}

function hotspotSetDefaults(settings, useModals) {
	settings.modals = !useModals ? false : settings.modals ? settings.modals : {};
	settings.items = settings.items || {};
	settings.classes = settings.classes || {};

	settings.classes.hotspot = settings.classes.hotspot || 'hotspot-style';
	settings.classes.modal = settings.classes.modal || 'modal-style';

	settings.classes.completed = settings.classes.completed || 'completed';
	settings.classes.linearUnlocked = settings.classes.linearUnlocked || 'unlocked';
	settings.classes.quizItemSelected = settings.classes.quizItemSelected || 'selected-hotspot';

	return settings;
}

function hotspotDOMSetup(slideObj, settings, $hotspots, modals) {
	$hotspots.addClass(settings.classes.hotspot);
	$hotspots.each(function (idx, hotspot) {
		$(hotspot).addClass(settings.classes.hotspot + '-' + (idx + 1));
	});

	if (!modals) return;

	var $modalContainer = modals && modals[0].parent();

	modals.forEach(function ($modal, idx) {
		$modal.addClass(settings.classes.modal);
		$modal.addClass(settings.classes.modal + '-' + (idx + 1));

		if (settings.modals.clickAnywhere) $modal.addClass('modal-click-anywhere');
	});
	if (settings.modals.hover || settings.modals.noModalClose) {
		addToFunctionKey(slideObj, 'onExitAction', function () {
			$modalContainer.removeClass('passthrough-modal');
		});
	}
}

function hotspotAudioInit(audioObj) {
	for (var key in audioObj) {
		audioObj[key] = new Howl({
			src: [audioObj[key]]
		});
	}
}

function hotspotOnWin(settings) {
	if (settings.onWin) settings.onWin();
	else slideAction(globalVar.slide.id, 'nextAction');
}

function hotspotUnlockNext(settings, $hotspots, nextHotspotItemNum, $nextHotspot, $nextModal) {
	var nextHotspotSettings = getItemSettings(settings.items, $nextHotspot.id, nextHotspotItemNum);

	$hotspots.removeClass(settings.classes.linearUnlocked);

	unlock($nextHotspot);
	$nextHotspot.addClass(settings.classes.linearUnlocked);

	hotspotCustomAction(
		settings.onUnlock,
		nextHotspotSettings && nextHotspotSettings.onUnlock,
		$nextHotspot,
		$nextModal
	);
}

function hotspotCloseRemainingModals(settings, $modalToClose, $hotspotToClose) {
	Howler.stop();
	if ($modalToClose.length <= 0) return;
	var itemToCloseSettings = getItemSettings(settings.items, $hotspotToClose[0].id, globalVar.hotspotItemNum);

	hotspotCustomAction(
		settings.onModalClose,
		itemToCloseSettings && itemToCloseSettings.onModalClose,
		$hotspotToClose,
		$modalToClose
	);
	$modalToClose.removeClass('si-current-modal');
	$modalToClose.parent().removeClass('si-modal-container-open');
	$hotspotToClose.removeClass('hotspot-open');
	$modalToClose.parent().removeClass('passthrough-modal');
}

function getHotspotModals(numOfModals) {
	var modals = [];

	if (slides[globalVar.curSlide].modal)
		for (var i = 1; i < numOfModals + 1; i++) {
			if (slides[globalVar.curSlide].modal['hs' + i])
				modals.push($('#' + slides[globalVar.curSlide].modal['hs' + i]));
		}
	return modals.length > 0 && modals; //returns false if no modals found
}

function hotspotListeners(settings, $hotspots, onInteract) {
	$hotspots.each(function (idx, hotspot) {
		var $hotspot = $(hotspot);

		if (settings.modals.hover) $hotspot.on('mouseover.hotspot', onInteract(idx, hotspot));
		else $hotspot.on('click.hotspot', onInteract(idx, hotspot));
	});
}

function hotspotPlayVO(settings, itemNum) {
	if (settings.audio) {
		Howler.stop();
		for (var key in settings.audio) settings.audio[key].stop();

		settings.audio[itemNum] && settings.audio[itemNum].play();
	}
}

function hotspotOnQuizItemSelected(settings, $hotspots, $selectedHotspot) {
	if (settings.quiz.type === 'scq') $hotspots.removeClass(settings.classes.quizItemSelected);

	$selectedHotspot.toggleClass(settings.classes.quizItemSelected);

	settings.quiz.selectedAnswers = [];
	$hotspots.each(function (idx, quizHotspot) {
		if ($(quizHotspot).hasClass(settings.classes.quizItemSelected)) settings.quiz.selectedAnswers.push(idx + 1);
	});
}

function hotspotItemComplete(settings, $hotspots, itemSettings, $completedButton, $completedModal) {
	hotspotCustomAction(
		settings.onItemComplete,
		itemSettings && itemSettings.onItemComplete,
		$completedButton,
		$completedModal
	);

	$completedButton.addClass(settings.classes.completed);

	if (allHotspotsCompleted($hotspots)) hotspotOnWin(settings, $hotspots);
}

function allHotspotsCompleted($hotspots) {
	return $hotspots.filter('.completed').length === $hotspots.length;
}

function hotspotSaveModalInfo(saveTo, itemNum, ID) {
	saveTo.currentModal = ID;
	saveTo.currentModalType = 'hotspot';
	saveTo.hotspotItemNum = itemNum;
}

function hotspotOpenModal(settings, itemNum, $selectedHotspot, $modal) {
	Howler.stop();
	var $modalContainer = $modal.parent();

	$selectedHotspot.addClass('hotspot-open');

	if (settings.modals.hover || settings.modals.noModalClose) $modalContainer.addClass('passthrough-modal');

	$modalContainer.addClass('si-modal-container-open');
	$modal.addClass('si-current-modal');

	hotspotSaveModalInfo(globalVar, itemNum, $modal[0].id);
}

function hotspotOnExit(slideObj) {
	addToFunctionKey(slideObj, 'onExitAction', function () {
		var $modalToClose = $('.si-current-modal');

		hotspotCloseRemainingModals(slideObj.hotspot, $modalToClose, $('.hotspot-open'));
	});
}

function hotspotCloseOnMouseOut($selectedHotspot, $modal) {
	var $modalContainer = $modal.parent();

	$selectedHotspot.one('mouseout.hotspot', function () {
		$modalContainer.trigger('click');

		$modalContainer.removeClass('passthrough-modal');
	});
}

function hotspotLinearReset(settings, $hotspots, modals) {
	var $firstHotspot = $($hotspots[0]);
	var $firstModal = modals && modals[0];

	$hotspots.removeClass(settings.classes.linearUnlocked);

	lock($hotspots);
	hotspotUnlockNext(settings, $hotspots, 1, $firstHotspot, $firstModal);
}

function hotspotQuizReset(settings, $hotspots) {
	$hotspots.removeClass(settings.classes.quizItemSelected);
	settings.quiz.selectedAnswers = [];
}

function hotspotCustomAction(mainAction, itemAction, $hotspot, $modal) {
	mainAction && mainAction($hotspot, $modal);
	itemAction && itemAction($hotspot, $modal);
}

function getItemSettings(settingsDir, id, itemNum) {
	return settingsDir[itemNum] || settingsDir[id];
}

function checkHotspot() {
	var quiz = slides[globalVar.curSlide].hotspot.quiz;
	if (!quiz) throw '\nHotspot Error:\nyou have to turn on the "quiz" settings to use hotspots this way';
	var correctAnswers = quiz.answers;
	var selectedAnswers = quiz.selectedAnswers;
	return JSON.stringify(selectedAnswers) === JSON.stringify(correctAnswers);
}
